import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../entity/grid/column.component";
import {AbstractColumnComponent} from "../../../entity/grid/abstract-column.component";

/**
 * Search grid column to render translated values
 */
@Component({
    selector: "wbo-translated-column",
    templateUrl: "./translated-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => TranslatedColumnComponent), multi: true}
    ]
})
export class TranslatedColumnComponent extends AbstractColumnComponent {
    @Input() prefix: string;
    @Input() message: string;
    @Input() messageRetriever: (dataItem: any) => string;

    constructor(injector: Injector) {
        super(injector);
    }
}
